/** Store records a menu item or a content block can point at. */
export type TargetKind =
  'product' | 'collection' | 'page' | 'policy' | 'blog_post' | 'blog_category';

export const TARGET_KINDS: readonly TargetKind[] = [
  'product',
  'collection',
  'page',
  'policy',
  'blog_post',
  'blog_category',
];

export interface TargetOption {
  id: string;
  label: string;
  /** The storefront path, shown under the label. */
  detail: string | null;
}

/** Storefront paths the backend resolves each target to (doc 15). */
export function targetPath(kind: TargetKind, handle: string): string {
  switch (kind) {
    case 'product':
      return `/products/${handle}`;
    case 'collection':
      return `/collections/${handle}`;
    case 'page':
      return `/pages/${handle}`;
    case 'policy':
      return `/policies/${handle}`;
    case 'blog_post':
      return `/blog/${handle}`;
    case 'blog_category':
      return `/blog/category/${handle}`;
  }
}
